import React from 'react';

const numberToClass = (number, prefix = '') => {
    let classes;
    let result;

    switch (number) {
        case 1:
            classes = 'one-twelfth';
            break;
    
        case 2:
            classes = 'two-twelfths';
            break;
        
        case 3:
            classes = 'three-twelfths';
            break;
        
        case 4:
            classes = 'four-twelfths';
            break;
        
        case 5:
            classes = 'five-twelfths';
            break;
        
        case 6:
            classes = 'six-twelfths';
            break;
        
        case 7:
            classes = 'seven-twelfths';
            break;
        
        case 8:
            classes = 'eight-twelfths';
            break;
        
        case 9:
            classes = 'nine-twelfths';
            break;
        
        case 10:
            classes = 'ten-twelfths';
            break;
        
        case 11:
            classes = 'eleven-twelfths';
            break;
        
        case 12:
            classes = 'one-whole';
            break;
        
        default:
            classes = '';
            break;
    }

    result = `${prefix}${classes}`;

    return result;
}

export const Grid = (props) => (
    <div className={`wrapper ${props.className}`}>
        {props.children}
    </div>
);

export const Row = (props) => (
    <div className={`grid ${props.className}`}>
        {props.children}
    </div>
);

export const Col = (props) => {
    const { xs, md, lg, className } = props;

    const xsClass = numberToClass(xs, 'small--');
    const mdClass = numberToClass(md, 'medium--');
    const lgClass = numberToClass(lg, 'large--');

    return (
        <div className={`grid__item ${xsClass} ${mdClass} ${lgClass} ${className}`}>
            {props.children}
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/GridSystem/index.js